import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drugs-info-page',
  templateUrl: './drugs-info-page.component.html',
  styleUrls: ['./drugs-info-page.component.css']
})
export class DrugsInfoPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
